const styles = {
  modal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: "8px",
  },
  title: {
    mb: 2,
  },
  formControl: {
    mb: 2,
  },
  textField: {
    mb: 2,
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    mt: 2,
  },
  cancelButton: {
    mr: 2,
  },
  submitButton: {
    backgroundColor: "#5958e1",
    "&:hover": {
      backgroundColor: "#4a49b3",
    },
  },
  responseLink: {
    textDecoration: "none",
    color: "#5958e1",
    "&:hover": {
      textDecoration: "underline",
    },
  },
};

export default styles;
